export default __webpack_public_path__ + "static/media/CuisineLogo.c3d32cf5.jpg";